import { Injectable, OnDestroy, inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'
import { Subscription } from 'rxjs'
import { showSpinner } from '../../store/handler/handler.selectors'
import { AppSpinnerComponent } from './app-spinner.component'

@Injectable({ providedIn: 'root' })
export class AppSpinnerService implements OnDestroy {
   private _store = inject(Store)
   private _dialogService = inject(DialogService)
   private spinnerDialogRef = inject(DynamicDialogRef<AppSpinnerComponent>)

   private _isShow?: boolean
   private _sub = new Subscription()

   constructor() {
      this._sub.add(
         this._store.select(showSpinner).subscribe((v) => {
            v ? this.showSpinner() : this._isShow ? this.closeSpinner() : null
         })
      )
   }

   public showSpinner() {
      this.spinnerDialogRef = this._dialogService.open(AppSpinnerComponent, {
         modal: true,
         closable: false,
         showHeader: false,
         focusOnShow: false,
         styleClass: 'shadow-none spinner-dialog-content contents',
      })
      this._isShow = true
   }

   private closeSpinner() {
      this.spinnerDialogRef?.close()
   }

   ngOnDestroy(): void {
      this.closeSpinner()
      this._sub.unsubscribe()
   }
}
